<form [formGroup]="csvConfigForm">
    <div mat-dialog-content class="dialog-content">
        <h1 mat-dialog-title>CSV Config</h1>
        <mat-form-field appearance="fill">
            <mat-label>Template</mat-label>
            <mat-select  name="template" formControlName="template">
                <mat-option *ngFor="let item of templateDropdownVal" [value]="item.value" >{{item.name}}</mat-option>
            </mat-select>
        </mat-form-field>
        <div class="dialog-form-group">
            <mat-form-field style=" margin: 0.6rem 0.6rem 0 0;">
                <mat-label>Latitude</mat-label>
                <mat-select  name="latitude" formControlName="latitude">
                    <mat-option *ngFor="let item of dropdownValues" [value]="item.value">{{item.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style=" margin: 0.6rem 0.6rem 0 0;">
                <mat-label>Longitude</mat-label>
                <mat-select  name="longitude" formControlName="longitude">
                    <mat-option *ngFor="let item of dropdownValues" [value]="item.value">{{item.name}}</mat-option>
                </mat-select>
             </mat-form-field>
        </div>
        <div class="dialog-form-group">
            <mat-form-field style=" margin: 0.6rem 0.6rem 0 0;">
                <mat-label>Elevation</mat-label>
                <mat-select  name="elevation" formControlName="elevation">
                    <mat-option *ngFor="let item of dropdownValues" [value]="item.value">{{item.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field  style=" margin: 0.6rem 0.6rem 0 0;">
                <mat-label>Name</mat-label>
                <mat-select  name="name" formControlName="name">
                    <mat-option *ngFor="let item of dropdownValues" [value]="item.value">{{item.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="dialog-form-group">
            <mat-form-field style=" margin: 0.6rem 0.6rem 0 0;">
                <mat-label>Comment</mat-label>
                <mat-select  name="comment" formControlName="comment">
                    <mat-option *ngFor="let item of dropdownValues" [value]="item.value">{{item.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <mat-checkbox style=" margin: 0.6rem 0.6rem 0 0;" name="name" formControlName="useLocalSettings">Use Locale Settings</mat-checkbox>
        <div class="dialog-form-group">
            <mat-form-field appearance="outline" style=" margin: 0.6rem 0.6rem 0 0;">
                <mat-label>Decimal Seperator</mat-label>
                <input matInput type="text" name="decimalSeperator" formControlName="decimalSeperator">
            </mat-form-field>
            <mat-form-field appearance="outline" style=" margin: 0.6rem 0.6rem 0 0;">
                <mat-label>Column Seperator</mat-label>
                <input matInput type="text"  name="columnSeperator" formControlName="columnSeperator">
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions>
      <button  mat-raised-button (click)="cancel()">Cancel</button>
      <button  mat-raised-button color="primary" type="submit" (click)="onSubmit()">Ok</button>
    </div>
  </form>